var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgJob = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Job_Center",
    "data-name": "Job Center",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portfolio_1_",
    "data-name": "portfolio (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-2",
    d: "M211,240h2.589v.863H211Zm0,0",
    transform: "translate(-204.931 -232.988)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-2",
    d: "M11.948,83.048H9.521v.439a.435.435,0,0,1-.431.439H5.638a.435.435,0,0,1-.431-.439v-.439H2.779a1.3,1.3,0,0,1-1.228-.9L0,77.41V87a1.308,1.308,0,0,0,1.294,1.317H13.432A1.308,1.308,0,0,0,14.727,87v-9.59l-1.551,4.737a1.3,1.3,0,0,1-1.228.9Zm0,0",
    transform: "translate(0 -75.184)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-2",
    d: "M34.156,0H30.7A1.3,1.3,0,0,0,29.41,1.294v.431h-3.6l1.627,4.882a.431.431,0,0,0,.41.295h2.427V6.472A.431.431,0,0,1,30.7,6.04h3.452a.431.431,0,0,1,.431.431V6.9h2.427a.431.431,0,0,0,.41-.295l1.627-4.882h-3.6V1.294A1.3,1.3,0,0,0,34.156,0ZM30.273,1.726V1.294A.432.432,0,0,1,30.7.863h3.452a.432.432,0,0,1,.431.431v.431Zm0,0",
    transform: "translate(-25.067)",
    fill: "#FFFFFF"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJob, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/job.8403a971.svg";
export { ForwardRef as ReactComponent };